import React from 'react';
import { Typography, Container, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NotFoundPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container component="main" maxWidth="md" sx={{ textAlign: 'center', mt: 10 }}>
            <Box>
                <Typography variant="h1" component="h1" gutterBottom>
                    404
                </Typography>
                <Typography variant="h4" component="h2" gutterBottom>
                    Page Not Found
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    The page you are looking for does not exist.
                </Typography>
                <Button variant="contained" onClick={() => navigate('/')}>
                    Go to Dashboard
                </Button>
            </Box>
        </Container>
    );
}

export default NotFoundPage;